import { Fragment } from "react";
import { Button, DatePicker } from "antd";

import { useSearchContext } from "components/contexts/searchcontext.ts";
import { useUserContext } from "components/contexts/usercontext";

import {
  MembershipTiers,
  isUserAtLeast,
  MembershipTierLimitCategories,
  getLimitForMembershipTierAndCategory,
  showMembershipTierLimitMessage,
} from "../../utils/user";

import { CHART_DATE_RANGES, QUICK_DATE_RANGES, STARTER_WAX_CHART_DATE_RANGES } from "./constants";

const RangePicker = ({ displayQuickOptions = false }) => {
  const searchContext = useSearchContext();

  const { user } = useUserContext();
  const isAtLeastPremium = isUserAtLeast(user, MembershipTiers.PREMIUM);
  // TODO: remove this horrible hack
  const isWithinWaxCharts = window.location.pathname.indexOf("/wax-charts") != -1;
  const cannotShowFullRange = !isAtLeastPremium && isWithinWaxCharts;
  const quickDatesRanges = QUICK_DATE_RANGES;

  const dateRangeUpperBound =
    !cannotShowFullRange ||
    window.location.pathname.indexOf("/playercharts") != -1 ||
    window.location.pathname.indexOf("/setyearcharts") != -1
      ? Infinity
      : getLimitForMembershipTierAndCategory(user.membership_tier, MembershipTierLimitCategories.DATE_RANGES);

  return (
    <div className="graph-rangepicker" style={{ display: "flex", alignItems: "center" }}>
      <DatePicker.RangePicker
        allowClear={false}
        defaultValue={[searchContext.startDate, searchContext.endDate]}
        value={[searchContext.startDate, searchContext.endDate]}
        format={"MM/DD/YYYY"}
        onCalendarChange={(change) => {
          searchContext.setStartDate(change[0]);
          searchContext.setEndDate(change[1]);
          searchContext.setDateRangeLabel();
        }}
        ranges={!cannotShowFullRange ? CHART_DATE_RANGES : STARTER_WAX_CHART_DATE_RANGES}
      />

      {displayQuickOptions && (
        <div className="graph-rangepicker-quick-options">
          <span style={{ marginLeft: 16 }}>Show Last:</span>
          {quickDatesRanges.map(({ label, value }, idx) => {
            const selected = searchContext.dateRangeLabel === label;

            return (
              <Fragment key={label}>
                <Button
                  style={{ padding: "4px 6px" }}
                  type={selected ? "text" : "link"}
                  onClick={() => {
                    const labelAsUpperBound = parseInt(label);
                    if (labelAsUpperBound > dateRangeUpperBound) {
                      showMembershipTierLimitMessage(
                        `Your plan includes data from the last ${dateRangeUpperBound} days only. Upgrade your plan to access additional time periods.`,
                      );
                    } else {
                      searchContext.setStartDate(value[0]);
                      searchContext.setEndDate(value[1]);
                      searchContext.setDateRangeLabel(label);
                    }
                  }}
                >
                  {label}
                </Button>
                {idx + 1 !== quickDatesRanges.length && <span style={{ margin: "0 6px" }}>|</span>}
              </Fragment>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default RangePicker;
